'use client';

import { useReducedMotionConfig } from 'motion/react';

/** The system setting or a surrounding `<MotionConfig reducedMotion>`; unknown (first server render) counts as no preference. */
function useMotionReduced(): boolean {
  return useReducedMotionConfig() === true;
}

export { useMotionReduced };
